import config from '../../config';

export const setAgentCookie = (token: string, tokenExpires: number) => {
	if (!token) {
		return;
	}

	const expiresInSeconds = Math.floor((tokenExpires - Date.now()) / 1000);
	if (expiresInSeconds < 0) {
		return;
	}

	document.cookie = 'n8n-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	if (config.ENV === 'PROD') {
		document.cookie = `upsales-auth=${token}; domain=upsales.com; path=/; max-age=${expiresInSeconds}; SameSite=None; Secure`;
	} else if (config.ENV === 'BETA') {
		document.cookie = `upsales-auth=${token}; domain=.upsales.com; path=/; max-age=${expiresInSeconds}; SameSite=None; Secure`;
	} else {
		document.cookie = `upsales-auth=${token}; path=/; max-age=${expiresInSeconds}; SameSite=None; Secure`;
	}
};

const getCookie = (name: string) => document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))?.at(2);

export const getAgentCookie = () => {
	return getCookie('upsales-auth');
};

export const clearAgentCookie = () => {
	document.cookie = 'n8n-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	if (config.ENV === 'PROD') {
		document.cookie = 'upsales-auth=; domain=upsales.com; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	} else if (config.ENV === 'BETA') {
		document.cookie = 'upsales-auth=; domain=.upsales.com; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	} else {
		document.cookie = 'upsales-auth=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}
};
